
/**
 * This component is resposible for adding markers representing stations that are deployed on
 * location where we have a model running.
 *
 * Those stations are added / removed each time the user moves to another location.
 */
import { mapState } from 'pinia';
import { Map } from 'mapbox-gl';

import { defineComponent, PropType } from 'vue';

import MapboxMarker from './mapbox-marker.vue';
import PollutionLayerStation from './pollution-layer-station.vue';

import { Station } from "../../api/models/station.model";
import { useStationStore } from '../../store/station.store';

export default defineComponent({
    props: {
        map: {
            type: Map,
            required: true,
        },
        stations: {
            type: Array as PropType<Station[]>,
            default: [],
        },
        currentStation: {
            type: Object as PropType<Station>,
        }
    },

    components: {
        MapboxMarker,
        PollutionLayerStation,
    },

    data() {
        return {
            loading: false,
        };
    },

    methods: {
        latLng(station: Station) {
            const { lat, lon } = station.location;
            return { lat, lng: lon };
        },
    },
});
